// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","headerSwitch":"Header_headerSwitch__BjZSw","workspacePath":"Header_workspacePath__2VM1q"};